(() => {
  function getSectionId() {
    const mg = document.querySelector('media-gallery[id^="MediaGallery-"]');
    if (!mg) return null;
    return mg.id.replace('MediaGallery-', '');
  }

  function setUrlVariantParam(variantId) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    window.history.replaceState({}, '', url.toString());
  }

  function syncMainFormVariantId(variantId) {
    // Keeps other scripts consistent
    const idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (idInput) idInput.value = variantId;
  }

  async function refreshGallery(variantId) {
    const sectionId = getSectionId();
    if (!sectionId || !variantId) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);
    url.searchParams.set('section_id', sectionId);

    const res = await fetch(url.toString(), { credentials: 'same-origin' });
    if (!res.ok) return;

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const newGallery = doc.querySelector(`#MediaGallery-${sectionId}`);
    const oldGallery = document.querySelector(`#MediaGallery-${sectionId}`);

    if (!newGallery || !oldGallery) return;

    oldGallery.replaceWith(newGallery);
    window.dispatchEvent(new Event('resize'));
  }

  async function applyVariant(variantId) {
    if (!variantId) return;
    syncMainFormVariantId(variantId);
    setUrlVariantParam(variantId);
    await refreshGallery(variantId);
  }

  // 1) Dawn reliable event (top variant picker)
  document.addEventListener('variant:change', (e) => {
    const v = e?.detail?.variant;
    if (v?.id) applyVariant(String(v.id));
  });

  // 2) Sticky dropdown (your hkStickyVariant-{{ section.id }})
  document.addEventListener('change', (e) => {
    const target = e.target;

    // if it's your sticky select
    if (target && target.matches('select[id^="hkStickyVariant-"]')) {
      const vid = target.value;
      applyVariant(String(vid));
      return;
    }

    // fallback: any selector changing the hidden id
    const idInput = document.querySelector('input[name="id"]');
    if (idInput?.value) {
      setTimeout(() => applyVariant(String(idInput.value)), 30);
    }
  });
})();
